import React from 'react'

import { Map } from '@peracto/peracto-blocks-tailwind'

import Form from './Form/MapForm'
import { defaultSettings } from './defaults/settings'

const createPlugin = settings => {
    const mergedSettings = { ...defaultSettings, ...settings }
    const RenderComponent = Map

    return {
        FormComponent: props => <Form {...props} />,
        Component: props => <RenderComponent.Component {...props} {...mergedSettings} />,

        name: 'peracto/content/map',
        version: '1.0.0',
        text: mergedSettings.translations.pluginName,
        description: mergedSettings.translations.pluginDescription,
        IconComponent: mergedSettings.IconComponent,

        createInitialState: () => ({
            text: mergedSettings.defaultText,
        }),
    }
}

export default createPlugin
